import type { AnyObject } from '../Types';

export type NovaModule = AnyObject;

export class MxNovaLoader {
	public isLoaded = false;
	private nova: NovaModule | undefined;
	async loadNova(): Promise<void> {
		if (this.nova) {
			return;
		}
		this.nova = await import('@matrix42/nova');

		const novaTheme = this.nova.createNovaTheme();
		novaTheme.fontFamily.sans = 'Roboto, "Helvetica Neue", sans-serif';
		novaTheme.fontSize.label = 1.2;
		novaTheme.fontSize.p = 1.4;
		novaTheme.fontSize.h6 = 1.6;
		novaTheme.fontSize.h5 = 1.8;
		novaTheme.fontSize.h4 = 2;
		novaTheme.fontSize.h3 = 2.4;
		novaTheme.fontSize.h2 = 3;
		novaTheme.fontSize.h1 = 3.6;
		novaTheme.fontSize['h1-xl'] = 4.8;
		novaTheme.fontSize['h1-2xl'] = 6;
		novaTheme.fontSize['h1-3xl'] = 7.2;
		novaTheme.fontSize.code = 1.4;

		this.nova.applyNovaTheme(novaTheme, 'light', 10);
		this.nova.provideNovaDesignSystem({ theme: novaTheme, themeMode: 'light' });

		this.isLoaded = true;
	}
}
